import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ChartRangeOptions } from '@core/models';

@Component({
  selector: 'xemex-period-selector',
  standalone: true,
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './period-selector.component.html',
})
export class PeriodSelectorComponent {
  options = input<ChartRangeOptions[]>([]);
  selected = input<ChartRangeOptions>(ChartRangeOptions.Day);
  /** Draws the control as a white bordered box, like a card, instead of on a grey track. */
  framed = input<boolean>(false);
  selectedChange = output<ChartRangeOptions>();
}
